import {PartnerData, ReferralStat} from 'yougile-model'
import {Backend} from '../../common/backend'
import {Listener, logger} from 'yougile-util'
import {PageService} from '../extensions/page-service'
import {ChatUtils} from '../extensions/chat-utils'

export class PartnerClient {
  public static listener = new Listener<(d: PartnerData) => void>()
  public static data: PartnerData
  public static stats: {[companyId: string]: ReferralStat} = {}

  public static init(): void {
    PartnerClient.listener.onNewListener(fn => {
      fn(PartnerClient.data)
    })
    PartnerClient.fetch()
  }

  public static async fetch(): Promise<PartnerData> {
    const resp = await Backend.postJSON('/data/partner/main', {
      ...Backend.loadCred()
    })

    PartnerClient.data = (resp as any).data
    PartnerClient.stats = (resp as any).stats ?? {}
    PartnerClient.listener.trigger(PartnerClient.data)
    const firstTimePartnerVisit = (resp as any).firstTimePartnerVisit
    if (firstTimePartnerVisit) {
      logger.log('Partner entry')
      PageService.goTo('partner')
      ChatUtils.closeChatIfOpened()
    }
    return PartnerClient.data
  }
}
